export const appendClassProps = (className) => {
    if (Array.isArray(className)) {
        return className.reduce((final, name) => {
            if (name) {
                final = final + ' ' + name;
            }
            return final;
        }, '');
    }
    return className ? ' ' + className : '';
};
/**
 * Returns whether the string conforms to the RFC 5322 Official Standard
 * @param candidate
 * @returns {boolean}
 */
export const isEmail = (candidate) => {
    // eslint-disable-next-line no-control-regex
    return /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(candidate);
};
//# sourceMappingURL=index.js.map